import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { Default_Country } from 'src/constants'
import { getSkuTableDataAsync } from 'src/services/shouldCostAIBased.services'

const initialState = {
  getSkuTableLoader: false,
  getSkuTableData: [],
  getSkuTableError: '',
}

export const getSkuTableSlice = createSlice({
  name: 'get-sku-table-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSkuTableDataAsync.pending), (state) => {
      state.getSkuTableLoader = true
    })
    builder.addMatcher(isAnyOf(getSkuTableDataAsync.fulfilled), (state, action) => {
      state.getSkuTableLoader = false
      const updatedData = action.payload?.data.map((item) => ({
        ...item,
        country: Default_Country.COUNTRY,
      }))

      state.getSkuTableData = updatedData
    })
    builder.addMatcher(isAnyOf(getSkuTableDataAsync.rejected), (state, action) => {
      state.getSkuTableLoader = false
      state.getSkuTableError = action?.payload?.message
    })
  },
})

export default getSkuTableSlice.reducer
